import { render, staticRenderFns } from "./LuckyPackageDialog.vue?vue&type=template&id=d88f2928&scoped=true&"
import script from "./LuckyPackageDialog.vue?vue&type=script&lang=js&"
export * from "./LuckyPackageDialog.vue?vue&type=script&lang=js&"
import style0 from "./LuckyPackageDialog.vue?vue&type=style&index=0&id=d88f2928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88f2928",
  null
  
)

export default component.exports